import React from "react"
import ReactDOM from "react-dom"

import App from "./occasions/App"

ReactDOM.render(
    React.createElement(App),
    document.querySelector("#occasions_root")
)
